import {
  Typography,
  Button,
  Tooltip,
  Icon,
  ICONS_ENUM
} from '@sanlam-glacier/app-common/components';
import styles from './asset-managers-card.module.scss';

import { AssetManager } from 'bff/client/models/AssetManager';
import {
  formatPercentageOfBook,
  formatRandValue
} from 'modules/dashboard/utils/formatting/currencyAndPercentageFormatter';

export const AssetManagerCard = ({
  assetManager,
  index
}: {
  assetManager: AssetManager;
  index: number;
}) => {
  const testComponentName = 'topAssetManagers';

  // For testing - TODO: Remove data tampering when integration is complete
  if (index === 0) {
    assetManager.companyURL = '';
  }
  return (
    <div
      data-testid={`${testComponentName}InformationCard_${index}`}
      className={styles.assetManagerCard}
    >
      <div className={styles.assetManagerName}>
        <Typography
          color={Typography.COLOR.INHERIT}
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.MEDIUM}
          style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}
          data-testid={`${testComponentName}AssetManagersName_${index}`}
        >
          {assetManager.assetManagerName}
        </Typography>
        <Typography
          color={Typography.COLOR.TERTIARY}
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.NORMAL}
          style={{ flexShrink: 0 }}
        >
          ({assetManager.companyAbbreviation})
        </Typography>
      </div>

      <Typography
        color={Typography.COLOR.TERTIARY}
        variant={Typography.VARIANT.B4}
        weight={Typography.WEIGHT.NORMAL}
        data-testid={`${testComponentName}TotalMarketValue_${index}`}
      >
        R {formatRandValue(assetManager.totalMarketValue)}
      </Typography>
      <div className={styles.percentageOfBook}>
        <Typography
          color={Typography.COLOR.INHERIT}
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.MEDIUM}
          data-testid={`${testComponentName}PercentageOfBook_${index}`}
        >
          {formatPercentageOfBook(assetManager.percentageOfBook, 0)}
        </Typography>
        <Typography
          color={Typography.COLOR.TERTIARY}
          variant={Typography.VARIANT.B4}
          weight={Typography.WEIGHT.NORMAL}
        >
          of book
        </Typography>
      </div>

      <Tooltip position={Tooltip.POSITION.RIGHT} content='Opens in new tab'>
        <span
          style={{
            position: 'absolute',
            bottom: '5px',
            right: '16px',
            display:
              assetManager.companyURL === '' || assetManager.companyURL === undefined
                ? 'none'
                : 'flex'
          }}
        >
          <Button
            data-testid={`${testComponentName}CompanyURL_${index}`}
            onClick={() => {
              window.open(assetManager.companyURL, '_blank')?.focus();
            }}
            size={Button.SIZE.SMALL}
            variant={Button.VARIANT.TERTIARY}
            style={{
              color: '#F15A22',
              background: 'none',
              paddingRight: '0px'
            }}
            fullWidth={false}
            endIcon={
              <Icon icon={ICONS_ENUM.ACTION_2_OPEN_IN_NEW} className={styles.openInNewIcon} />
            }
          >
            Visit site
          </Button>
        </span>
      </Tooltip>
    </div>
  );
};
